import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ItineraryButtonModel extends ButtonBase {
    label: string = 'Confirmation';
    action: string = ACTION_STATUS.itinerary;
    matIconName: string = 'flight';
    colorClass: string = 'color-info-500';
}